import { Observable } from './druid/./druid/Observable';
import { empty as staticEmpty } from './druid/./druid/observable/empty';

Observable.empty = staticEmpty;

declare module './druid/./druid/Observable' {
  namespace Observable {
    export let empty: typeof staticEmpty;
  }
}